export const gymData = {
  name: "FitZone Gym",
  tagline: "Transform Your Body, Transform Your Life",
  hero: {
    headline: "Your Fitness Journey Starts Here",
    subtext: "State-of-the-art equipment, expert trainers, and a community that supports your goals."
  },
  classes: [
    { id: 1, name: "HIIT Training", duration: "45 min", difficulty: "Advanced", time: "6:00 AM", instructor: "Mike Johnson" },
    { id: 2, name: "Yoga Flow", duration: "60 min", difficulty: "Beginner", time: "7:00 AM", instructor: "Sarah Williams" },
    { id: 3, name: "Spin Class", duration: "45 min", difficulty: "Intermediate", time: "8:00 AM", instructor: "Tom Brown" },
    { id: 4, name: "Strength Training", duration: "60 min", difficulty: "All Levels", time: "5:00 PM", instructor: "Lisa Davis" },
    { id: 5, name: "Zumba Dance", duration: "45 min", difficulty: "Beginner", time: "6:00 PM", instructor: "Maria Garcia" },
    { id: 6, name: "CrossFit", duration: "60 min", difficulty: "Advanced", time: "7:00 PM", instructor: "Jake Wilson" }
  ],
  trainers: [
    { id: 1, name: "Mike Johnson", specialty: "HIIT & CrossFit", experience: "8 years", avatar: "https://api.dicebear.com/7.x/avataaars/svg?seed=Mike" },
    { id: 2, name: "Sarah Williams", specialty: "Yoga & Pilates", experience: "6 years", avatar: "https://api.dicebear.com/7.x/avataaars/svg?seed=Sarah" },
    { id: 3, name: "Tom Brown", specialty: "Cycling & Cardio", experience: "5 years", avatar: "https://api.dicebear.com/7.x/avataaars/svg?seed=Tom" }
  ],
  memberships: [
    { id: 1, name: "Basic", price: "₹999", period: "per month", features: ["Gym Access", "Locker Facility", "Basic Equipment"] },
    { id: 2, name: "Pro", price: "₹1,999", period: "per month", popular: true, features: ["All Basic Features", "Group Classes", "Personal Locker", "Nutrition Guide"] },
    { id: 3, name: "Elite", price: "₹3,999", period: "per month", features: ["All Pro Features", "Personal Trainer", "Diet Plan", "Steam & Sauna", "Priority Booking"] }
  ]
};

export const salonData = {
  name: "Glamour Salon & Spa",
  tagline: "Where Beauty Meets Excellence",
  hero: {
    headline: "Unleash Your Inner Beauty",
    subtext: "Premium salon services with expert stylists and luxury treatments."
  },
  services: [
    { id: 1, category: "Hair", name: "Haircut & Styling", price: "₹500 - ₹1,500", duration: "60 min" },
    { id: 2, category: "Hair", name: "Hair Coloring", price: "₹2,000 - ₹5,000", duration: "120 min" },
    { id: 3, category: "Hair", name: "Hair Spa Treatment", price: "₹1,200", duration: "90 min" },
    { id: 4, category: "Skin", name: "Facial Treatment", price: "₹1,000 - ₹3,000", duration: "60 min" },
    { id: 5, category: "Skin", name: "Cleanup", price: "₹800", duration: "45 min" },
    { id: 6, category: "Nails", name: "Manicure & Pedicure", price: "₹1,200", duration: "75 min" },
    { id: 7, category: "Makeup", name: "Bridal Makeup", price: "₹15,000+", duration: "180 min" },
    { id: 8, category: "Makeup", name: "Party Makeup", price: "₹3,000", duration: "90 min" }
  ],
  staff: [
    { id: 1, name: "Priya Sharma", role: "Senior Hair Stylist", experience: "10 years", avatar: "https://api.dicebear.com/7.x/avataaars/svg?seed=Priya" },
    { id: 2, name: "Neha Patel", role: "Makeup Artist", experience: "7 years", avatar: "https://api.dicebear.com/7.x/avataaars/svg?seed=Neha" },
    { id: 3, name: "Anjali Reddy", role: "Skin Specialist", experience: "8 years", avatar: "https://api.dicebear.com/7.x/avataaars/svg?seed=Anjali" }
  ],
  gallery: [
    "https://images.unsplash.com/photo-1560066984-138dadb4c035?w=400&q=80",
    "https://images.unsplash.com/photo-1522337360788-8b13dee7a37e?w=400&q=80",
    "https://images.unsplash.com/photo-1595475884562-073c30d45670?w=400&q=80",
    "https://images.unsplash.com/photo-1487412947147-5cebf100ffc2?w=400&q=80",
    "https://images.unsplash.com/photo-1516975080664-ed2fc6a32937?w=400&q=80",
    "https://images.unsplash.com/photo-1519699047748-de8e457a634e?w=400&q=80"
  ]
};

export const photographerData = {
  name: "Capture Moments Photography",
  tagline: "Preserving Your Precious Memories",
  hero: {
    headline: "Every Moment Tells A Story",
    subtext: "Professional photography services for weddings, events, portraits, and more."
  },
  portfolio: [
    { id: 1, title: "Wedding Photography", image: "https://images.unsplash.com/photo-1519741497674-611481863552?w=600&q=80", category: "Wedding" },
    { id: 2, title: "Pre-Wedding Shoot", image: "https://images.unsplash.com/photo-1606800052052-a08af7148866?w=600&q=80", category: "Pre-Wedding" },
    { id: 3, title: "Portrait Session", image: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=600&q=80", category: "Portrait" },
    { id: 4, title: "Family Photography", image: "https://images.unsplash.com/photo-1511895426328-dc8714191300?w=600&q=80", category: "Family" },
    { id: 5, title: "Event Coverage", image: "https://images.unsplash.com/photo-1505236858219-8359eb29e329?w=600&q=80", category: "Event" },
    { id: 6, title: "Product Photography", image: "https://images.unsplash.com/photo-1523275335684-37898b6baf30?w=600&q=80", category: "Product" }
  ],
  packages: [
    {
      id: 1,
      name: "Basic Package",
      price: "₹15,000",
      duration: "4 hours",
      features: ["1 Photographer", "200+ Photos", "Online Gallery", "Basic Editing"]
    },
    {
      id: 2,
      name: "Premium Package",
      price: "₹30,000",
      duration: "8 hours",
      popular: true,
      features: ["2 Photographers", "500+ Photos", "Online Gallery", "Advanced Editing", "Photo Album", "Same Day Highlights"]
    },
    {
      id: 3,
      name: "Luxury Package",
      price: "₹60,000",
      duration: "Full Day",
      features: ["3 Photographers", "1000+ Photos", "Cinematic Video", "Drone Coverage", "Premium Album", "Canvas Prints", "Pre-Wedding Shoot"]
    }
  ]
};

export const restaurantData = {
  name: "Spice Garden Restaurant",
  tagline: "A Symphony of Flavors",
  hero: {
    headline: "Authentic Cuisine, Memorable Experience",
    subtext: "Savor the finest dishes crafted with love and the freshest ingredients."
  },
  menu: [
    {
      category: "Starters",
      items: [
        { id: 1, name: "Paneer Tikka", price: "₹250", description: "Grilled cottage cheese with Indian spices", vegetarian: true },
        { id: 2, name: "Chicken Kebab", price: "₹300", description: "Tender chicken marinated in aromatic spices", vegetarian: false },
        { id: 3, name: "Crispy Corn", price: "₹180", description: "Golden fried corn kernels with spices", vegetarian: true }
      ]
    },
    {
      category: "Main Course",
      items: [
        { id: 4, name: "Butter Chicken", price: "₹350", description: "Rich and creamy tomato-based chicken curry", vegetarian: false },
        { id: 5, name: "Paneer Butter Masala", price: "₹280", description: "Cottage cheese in creamy tomato gravy", vegetarian: true },
        { id: 6, name: "Dal Makhani", price: "₹220", description: "Black lentils cooked overnight with cream", vegetarian: true },
        { id: 7, name: "Biryani (Veg/Chicken)", price: "₹250/₹320", description: "Aromatic rice with spices and herbs", vegetarian: true }
      ]
    },
    {
      category: "Breads",
      items: [
        { id: 8, name: "Butter Naan", price: "₹50", description: "Soft leavened bread with butter", vegetarian: true },
        { id: 9, name: "Garlic Naan", price: "₹60", description: "Naan topped with garlic and coriander", vegetarian: true },
        { id: 10, name: "Tandoori Roti", price: "₹40", description: "Whole wheat flatbread", vegetarian: true }
      ]
    },
    {
      category: "Desserts",
      items: [
        { id: 11, name: "Gulab Jamun", price: "₹80", description: "Sweet milk dumplings in sugar syrup", vegetarian: true },
        { id: 12, name: "Kulfi", price: "₹90", description: "Traditional Indian ice cream", vegetarian: true }
      ]
    }
  ],
  specialties: [
    { id: 1, name: "North Indian", icon: "🍛" },
    { id: 2, name: "Chinese", icon: "🥢" },
    { id: 3, name: "Continental", icon: "🍝" },
    { id: 4, name: "Desserts", icon: "🍰" }
  ],
  hours: {
    weekdays: "11:00 AM - 11:00 PM",
    weekends: "11:00 AM - 12:00 AM"
  }
};
